/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_ConfirmInputs */

const en_admin_dashboard_confirm = /** @type {(inputs: Admin_Dashboard_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm`)
};

const de_admin_dashboard_confirm = /** @type {(inputs: Admin_Dashboard_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestätigen`)
};

const es_admin_dashboard_confirm = /** @type {(inputs: Admin_Dashboard_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar`)
};

const fr_admin_dashboard_confirm = /** @type {(inputs: Admin_Dashboard_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmer`)
};

const nl_admin_dashboard_confirm = /** @type {(inputs: Admin_Dashboard_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bevestigen`)
};

const it_admin_dashboard_confirm = /** @type {(inputs: Admin_Dashboard_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conferma`)
};

const pt_br2_admin_dashboard_confirm = /** @type {(inputs: Admin_Dashboard_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar`)
};

const pl_admin_dashboard_confirm = /** @type {(inputs: Admin_Dashboard_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potwierdź`)
};

const hu_admin_dashboard_confirm = /** @type {(inputs: Admin_Dashboard_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Megerősítés`)
};

const ro_admin_dashboard_confirm = /** @type {(inputs: Admin_Dashboard_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmati`)
};

/**
* | output |
* | --- |
* | "Confirm" |
*
* @param {Admin_Dashboard_ConfirmInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_confirm = /** @type {((inputs?: Admin_Dashboard_ConfirmInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_ConfirmInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_confirm(inputs)
	if (locale === "de") return de_admin_dashboard_confirm(inputs)
	if (locale === "es") return es_admin_dashboard_confirm(inputs)
	if (locale === "fr") return fr_admin_dashboard_confirm(inputs)
	if (locale === "nl") return nl_admin_dashboard_confirm(inputs)
	if (locale === "it") return it_admin_dashboard_confirm(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_confirm(inputs)
	if (locale === "pl") return pl_admin_dashboard_confirm(inputs)
	if (locale === "hu") return hu_admin_dashboard_confirm(inputs)
	return ro_admin_dashboard_confirm(inputs)
});
export { admin_dashboard_confirm as "admin.dashboard.confirm" }